let apiServicesApi = {
    async get(token, companyId, params=[]){
        let response = await window.axios.get('/api/api-services', {
            params:{
                api_token:token,
                company_logged:companyId,
                ...params
            }
        });
        return response.data;
    },
}

export default apiServicesApi